import React,{Fragment, useEffect, useState} from 'react'
import axios from 'axios'
import { baseUrl } from "../Common/Constants";
import { useSelector } from 'react-redux';
import { getParamsSelector } from '../Common/Slices/ParamSlice';
import AlarmComboChart from '../Common/Components/Charts/ComboChart';
import FormatMachineTimes from './FormatMachineTimes'
import Filters from '../Devices/Filter';
import Dashboard from '../Common/Components/Dashboard';
import MachineTimesChartWidget from './MachineTimesChartWidget';
import MachineTimesOptions from './MachineTimesOptions';
import MachineTimesGridWidget from './MachineTimesGridWidget';
import CumulativeChartWidget from './CumulativeChartWidget';
import DashboardOptions from '../Common/Components/DashboardOptions';
import { useAppDispatch } from "../Core/store.hooks";
import { fetchMachineTimes } from "../MachineTimes/slice";

interface MachineStateProps{
    id: string;
    header: string;
}

const MachineStateOverView = () =>{
    const dispatch = useAppDispatch();
    const params = useSelector(getParamsSelector);
    useEffect(() => {
        if (params != null) {
            dispatch(fetchMachineTimes(params));
        }
    }, [params]);

    const positionData = 
    [{ col: 4, colSpan: 3, rowSpan: 3 },
    { col: 4, colSpan: 3, rowSpan: 3 },
            { col: 1, colSpan: 3, rowSpan: 6 },
            { col: 1, colSpan: 3, rowSpan: 6 },
            { col: 1, colSpan: 3, rowSpan: 6 },
            { col: 1, colSpan: 3, rowSpan: 6 },
            { col: 1, colSpan: 3, rowSpan: 6 },
            { col: 1, colSpan: 3, rowSpan: 6 }];

    const positionDataCumulative = 
    [
    { col: 1, colSpan: 3, rowSpan: 3 },  
    { col: 4, colSpan: 3, rowSpan: 3 },
    { col: 4, colSpan: 3, rowSpan: 3 },
            { col: 1, colSpan: 3, rowSpan: 3 },
            { col: 1, colSpan: 3, rowSpan: 6 },
            { col: 1, colSpan: 3, rowSpan: 6 },
            { col: 1, colSpan: 3, rowSpan: 6 },
            { col: 1, colSpan: 3, rowSpan: 6 },
            { col: 1, colSpan: 3, rowSpan: 6 }];


    const sidebarItems = [
      {title: "Filters", item:<Filters id="1" scopeOrderInput={true} deviceWithSerialInput ="hidden"/>, expanded: true},
      {title: "Chart Options", item:<MachineTimesOptions />, expanded: true},
      {title: "Dashboard Options", item: < DashboardOptions />, expanded: true }
  ];

  if(params.scope === "cadid"){
    return (
    <Fragment>
        <Dashboard positionData={positionDataCumulative} sidebarItems={sidebarItems}>
          <CumulativeChartWidget id="machine-times-cumulative" header='Cumulative Machine Times'/>
          <MachineTimesChartWidget id='machine-times-widget' header='Total Machine Times' values='machineTimes'/>
          <MachineTimesChartWidget id='machine-times-per-day-widget' header='Machine Times Daily Average' values='machineTimesPerDay'/>
          <MachineTimesGridWidget id="machine-times-grid-widget" header="Machine Times Grid" />
        </Dashboard>
    </Fragment>)
  }
  return (
    <Fragment>
        <Dashboard positionData={positionData} sidebarItems={sidebarItems}>
        <MachineTimesChartWidget id='machine-times-widget' header='Total Machine Times' values='machineTimes'/>
        <MachineTimesChartWidget id='machine-times-per-day-widget' header='Machine Times Daily Average' values='machineTimesPerDay'/>
        <MachineTimesGridWidget id="machine-times-grid-widget" header="Machine Times Grid" />
      </Dashboard>
    </Fragment>
  )
}

export default MachineStateOverView;